import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Star, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";

// Dashboard: this week's featured game (picked automatically each Sunday) and progress to its bonus badge.
export const GameOfWeekCard = () => {
  const [g, setG] = useState(null);
  useEffect(() => { api.get("/game-of-week").then(({ data }) => setG(data)).catch(() => {}); }, []);
  if (!g) return null;
  const plays = Math.min(g.plays || 0, g.plays_needed);
  return (
    <section className="mt-10 rounded-3xl border border-primary/40 bg-primary/5 p-6" data-testid="gotw-card">
      <p className="flex items-center gap-2 font-mono text-[11px] uppercase tracking-widest text-primary"><Star size={13} /> Game of the week</p>
      <h2 className="mt-2 font-serif text-2xl" data-testid="gotw-title">{g.label}</h2>
      <p className="mt-1 text-sm text-muted-foreground">Play it {g.plays_needed} times this week (any mode) to earn the Game of the Week badge.</p>
      <div className="mt-3 flex items-center gap-2" data-testid="gotw-progress" aria-label={`${plays} of ${g.plays_needed} plays`}>
        {Array.from({ length: g.plays_needed }, (_, i) => <span key={i} className={`h-3 w-10 rounded-full ${i < plays ? "bg-primary" : "bg-border"}`} />)}
        <span className="ml-2 text-sm">{g.earned ? <b className="text-primary" data-testid="gotw-earned">Badge earned!</b> : `${plays} of ${g.plays_needed}`}</span>
      </div>
      {g.locked ? (
        <Link to="/payment" className="mt-4 inline-flex items-center gap-1.5 rounded-full border border-primary px-5 py-2 text-sm font-semibold text-primary" data-testid="gotw-locked">Unlock a course to play <ArrowRight size={14} /></Link>
      ) : (
        <Link to={g.link} className="mt-4 inline-flex items-center gap-1.5 rounded-full bg-primary px-5 py-2 text-sm font-semibold text-primary-foreground" data-testid="gotw-play">Play now <ArrowRight size={14} /></Link>
      )}
    </section>
  );
};
